
import { defineComponent } from "vue"
import CardPoolsForm from "@/components/card_pools/Form.vue"

export default defineComponent({
  components: {
    CardPoolsForm
  }
})
